export type CamelCase<T> = T extends `${infer A}_${infer B}`
  ? `${A}${Capitalize<CamelCase<B>>}`
  : T;

export type StorageType =
  | 'appearance_mode'
  | 'linking_social_connector'
  | 'checkout_session'
  | 'redirect_after_sign_in'
  | 'webhook_test_result'
  | 'is_dev_features_enabled'
  | 'oss_sidebar_cloud_upsell_dismissed_until'
  | 'license_usage_banner_dismissed_until'
  | 'manage_account_self_reconsent_attempted'
  | 'subscription_cancel_feedback_submitted';

export const getStorageKey = <T extends StorageType>(forType: T) =>
  `logto:admin_console:${forType}` as const;

export const storageKeys = Object.freeze({
  appearanceMode: getStorageKey('appearance_mode'),
  linkingSocialConnector: getStorageKey('linking_social_connector'),
  checkoutSession: getStorageKey('checkout_session'),
  /** The react-router redirect location after sign in. The value should be a stringified Location object. */
  redirectAfterSignIn: getStorageKey('redirect_after_sign_in'),
  webhookTestResult: getStorageKey('webhook_test_result'),
  /** Whether the under-development features are enabled. */
  isDevFeaturesEnabled: getStorageKey('is_dev_features_enabled'),
  /** The local expiry timestamp for dismissing the OSS sidebar cloud upsell card. */
  ossSidebarCloudUpsellDismissedUntil: getStorageKey('oss_sidebar_cloud_upsell_dismissed_until'),
  /** The local expiry timestamp for dismissing the self-hosted license usage banner. */
  licenseUsageBannerDismissedUntil: getStorageKey('license_usage_banner_dismissed_until'),
  /** Whether this tab session has already re-consented for `CloudScope.ManageAccountSelf`. */
  manageAccountSelfReconsentAttempted: getStorageKey('manage_account_self_reconsent_attempted'),
  /** Whether this tab session has submitted cancellation feedback for a tenant, suffixed with the tenant ID. */
  subscriptionCancelFeedbackSubmitted: getStorageKey('subscription_cancel_feedback_submitted'),
} satisfies Record<CamelCase<StorageType>, string>);
